import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/EmployeeListSlice';
import { actions } from '../slices/EmployeeSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';
import { call } from 'redux-saga/effects';

function formatPhoneNumber(phoneNumber, globalize = true) {
    if (globalize) {
        if (phoneNumber[0] === '0') {
            return `+84${phoneNumber.slice(1)}`;
        }

        return `+84${phoneNumber}`;
    } else {
        if (phoneNumber[0] !== '0') {
            return `0${phoneNumber}`;
        }

        return phoneNumber;
    }
}

const getSearchCriteria = (state) => state.employeeList.searchCriteria;

function* getEmployeeList({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_staff')}`, {
            params: {
                ...filters,
                size: limit,
                page: page ? page - 1 : null,
            },
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* createEmployee({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_staff')}`, {
            ...params,
        });
        yield put({ type: actions.create_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_employee_failed.type, payload: error });
    }
}

function* createUserAndEmployee({ payload: { params } }) {
    try {
        const newUser = {
            ...params,
            phone_number: formatPhoneNumber(params.phone_number, true),
        };

        const createUserResult = yield NetworkHandler.post(`${config.getUrl('user', 'futa_user')}`, newUser);

        params.user_id = createUserResult.data.user_id;

        const response = yield NetworkHandler.post(`${config.getUrl('bus_staff')}`, {
            ...params,
        });

        yield put({ type: actions.create_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_employee_failed.type, payload: error });
    }
}

function* updateEmployee({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_staff')}/${params.id}`, {
            ...params,
        });
        yield put({ type: actions.create_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_employee_failed.type, payload: error });
    }
}

function* assignRoleEmployee({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_roles')}/assign`, {
            ...params,
        });
        yield put({ type: actions.assign_role_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.assign_role_employee_failed.type, payload: error });
    }
}

function* deleteEmployee({ payload: { id } }) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_staff')}/${id}`);
        yield put({ type: actions.delete_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.delete_employee_failed.type, payload: error });
    }
}

function* depositEmployee({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_deposit')}`, {
            ...params,
        });
        yield put({ type: actions.deposit_employee_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.deposit_employee_failed.type, payload: error });
    }
}


function* exportEmployee({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_staff')}`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        const action = { pgae: 0, limit: 10, filters };
        yield call(getEmployeeList, { payload: action });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getEmployeeList);
    yield takeLatest(actions.create_employee.type, createEmployee);
    yield takeLatest(actions.update_employee.type, updateEmployee);
    yield takeLatest(actions.delete_employee.type, deleteEmployee);
    yield takeLatest(actions.deposit_employee.type, depositEmployee);
    yield takeLatest(actions.assign_role_employee.type, assignRoleEmployee);
    yield takeLatest(actions.create_user_and_employee.type, createUserAndEmployee);
    yield takeLatest(actions.export_employee.type, exportEmployee);
}

export default watchRequestDetail;
